









































import Vue from 'vue';
import BaseIcon from '@core/components/UI/BaseIcon.vue';
import { HeadlineWithRelatedArticles } from '@headlines/types/headline';

interface Props {
  headline: HeadlineWithRelatedArticles;
  onTop: boolean;
  size: string;
}

interface Data {
  iconList: Record<string, string>;
  contentType: {
    career: boolean;
    detector: boolean;
    detectorCategory: boolean;
    video: boolean;
    gallery: boolean;
    stream: boolean;
    streamSoon: boolean;
    audio: boolean;
    trending: boolean;
  };
}

interface Computed {
  classModifier: Record<string, any>;
}

interface Methods {
  hasTagId: (tagId: number) => boolean;
  isPrimaryCategory: (categoryId: number) => boolean;
}

const iconList = {
  gallery: 'gallery',
  video: 'play',
  audio: 'microphone',
  trending: 'trending',
};

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    BaseIcon,
  },
  props: {
    headline: {
      type: Object,
      required: false,
      default: null,
    },
    onTop: {
      type: Boolean,
      default: true,
      required: false,
    },
    size: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      iconList,
      contentType: {
        career: this.headline?.tags?.items?.find(tag => [89580921, 89580923, 89580941, 89580979, 89580981, 89969303].includes(tag.id)) ? true : false,
        detector: this.headline?.primaryCategory?.parentCategory?.id == 85827763 ? true : false,
        detectorCategory:
          this.headline?.primaryCategory?.id && [92719795, 88122145, 85827871, 85827867, 85827865].includes(this.headline?.primaryCategory?.id) ? true : false,
        video: this.headline?.relatedEntities?.hasVideo && this.headline?.primaryCategory?.channel.url !== 'www.delfi.lt/video',
        gallery: this.headline?.relatedEntities?.hasGallery,
        stream: this.headline?.relatedEntities?.hasStream,
        streamSoon: this.headline?.settings?.find(setting => setting.key === 'streamSoon')?.value ?? false,
        sustainableCourse: this.headline?.tags?.items?.find(tag => [91160101].includes(tag.id)) ? true : false,
        audio: this.headline?.relatedEntities?.hasAudio,
        trending: this.headline?.settings?.find(setting => setting.key === 'trending')?.value ?? false,
      },
    };
  },
  computed: {
    classModifier() {
      return {
        'C-headline-icons--on-top': this.onTop,
        'C-headline-icons--small': this.contentType.streamSoon,
        [`C-headline-icons--${this.size}`]: !!this.size,
      };
    },
  },
  methods: {
    hasTagId(tagId) {
      return this.headline.tags?.items?.find(tag => tag.id === tagId) ? true : false;
    },
    isPrimaryCategory(categoryId) {
      return this.headline.primaryCategory?.id === categoryId ? true : false;
    },
  },
});
